import { filter } from 'lodash';

export const filterText = (data, text) => {
  if (text === '') return data;

  const predicate = (o) => {
    for (const k in o) {
      let v = o[k];

      if (typeof v === 'object') {
        // combine any nested values so they are filterable too
        let combined_value = '';
        for (const key in v) {
          combined_value += v[key] + ' ';
        }

        v = combined_value;
      }

      if (typeof v === 'Number') continue;

      const coercedValue = String(v);

      if (coercedValue.trim().toLowerCase().includes(text)) {
        return true;
      }
    }
    return false;
  };

  return filter(data, predicate);
};
